import React from "react";
import Form from "react-bootstrap/Form";

// Use React.forwardRef to allow the component to receive refs
const FormField = React.forwardRef(({ error, label, ...props }, ref) => {
  return (
    <>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control
        ref={ref} // Pass the ref to the actual input element
        isInvalid={error}
        {...props}
      />
      {error && (
        <Form.Control.Feedback type="invalid">
          {error.message}
        </Form.Control.Feedback>
      )}
    </>
  );
});

// Add display name for debugging
FormField.displayName = "FormField";

export default FormField;
